<template>
  <div class="container">
    <div class="nav-btn cover" @click="shownav" v-show="!show_navlist">
      <img src="../assets/images/list.png"  v-if="lang == 'cn'" alt="" srcset="">
      <img src="../assets/images/list_en.png" v-if="lang == 'en'" alt="" srcset="">
    </div>
    <transition name="navtransition">
      <div class="product_list cover" v-show="show_navlist">
        <div class="product_title" :style=" { lineHeight: lang === 'cn' ? '60px' : '30px', fontSize: lang === 'cn' ? '20px' : '18px' } ">
          <span v-if="lang == 'cn'">精诚数字展厅</span>
          <span v-if="lang == 'en'">JC-TIMES Digital<br/> Exhibition Hall</span>
          <a href="javascript:;" class="close" @click="closenav">
            <svg t="1665382729038" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5512" width="22" height="22">
              <path d="M512 1024C228.072727 1024 0 795.927273 0 512S228.072727 0 512 0s512 228.072727 512 512-228.072727 512-512 512z m0-46.545455c256 0 465.454545-209.454545 465.454545-465.454545S768 46.545455 512 46.545455 46.545455 256 46.545455 512s209.454545 465.454545 465.454545 465.454545z m0-514.327272l148.945455-148.945455c13.963636-13.963636 34.909091-13.963636 48.872727 0 13.963636 13.963636 13.963636 34.909091 0 48.872727L560.872727 512l148.945455 148.945455c13.963636 13.963636 13.963636 34.909091 0 48.872727-13.963636 13.963636-34.909091 13.963636-48.872727 0L512 560.872727l-148.945455 148.945455c-13.963636 13.963636-34.909091 13.963636-48.872727 0-13.963636-13.963636-13.963636-34.909091 0-48.872727l148.945455-148.945455-148.945455-148.945455c-13.963636-13.963636-13.963636-34.909091 0-48.872727 13.963636-13.963636 34.909091-13.963636 48.872727 0l148.945455 148.945455z" fill="#333333" p-id="5513"></path>
            </svg>
          </a>
        </div>

        <div class="product_item" v-for="(list,index) in itemlist" :key="index">
            <router-link :to="list.linkurl" class="gotolink" v-if="list.isLimits">
              <div class="image_con">
                <img :src="list.imgurl" alt="" srcset="">
              </div>
              <div class="title-name" v-show="lang == 'cn'">{{list.name}}</div>
              <div class="title-name" v-show="lang == 'en'">{{list.en_name}}</div>
              <!-- <div class="title" v-show="lang == 'cn'">{{list.name}}</div>
              <div class="title" v-show="lang == 'en'">{{list.en_name}}</div> -->
            </router-link>
        </div>

        <!-- <div class="product_item">
          <router-link to="fpq" class="gotolink">
            <img src="../assets/images/fpq.jpg" alt="" srcset="">
            <div class="title">分配器</div>
          </router-link>
        </div> -->
      </div>
    </transition>
  </div>

</template>

<script>
import language from './language.vue';

  export default{
    components: {
      language,
    },
    data(){
      return {
        data:null,
        lang:'cn',
        show_navlist:false,
        itemlist:[
          {
            name:'计量泵',
            en_name:'Metering Pump',
            linkurl:'jlb',
            imgurl:require('../assets/images/jlb.jpg'),  // 607×607
            isLimits:false,
          },
          {
            name:'三层镶块分配器',
            en_name:'Feedblock',
            linkurl:'fpq',
            imgurl:require('../assets/images/fpq.jpg'),
            isLimits:false,
          },
          {
            name:'片材模头',
            en_name:'JC-S',
            linkurl:'pcmt',
            imgurl:require('../assets/images/pcmt.jpg'),
            isLimits:false,
          },
          {
            name:'片材模头-斜阻流棒',
            en_name:'JC-AR',
            linkurl:'zlb',
            imgurl:require('../assets/images/zlb.jpg'),
            isLimits:false,
          },
          {
            name:'拆模小车',
            en_name:'Maintenance Cart',
            linkurl:'cmxc',
            imgurl:require('../assets/images/cmxc.jpg'),
            isLimits:false,
          },
          {
            name:'静态混合器',
            en_name:'Static Mixer',
            linkurl:'jthhq',
            imgurl:require('../assets/images/jthhq.jpg'),
            isLimits:false,
          },
          {
            name:'板式换网器',
            en_name:'Slide-plate screen changer',
            linkurl:'bshwq',
            imgurl:require('../assets/images/bshwq.png'),
            isLimits:false,
          },
          {
            name:'双柱换网器',
            en_name:'Double-piston screen changer',
            linkurl:'szhwq',
            imgurl:require('../assets/images/szhwq.jpg'),
            isLimits:false,
          },
          {
            name:'摆杆型快速开口装置',
            en_name:'Swing-arm type rapid opening die',
            linkurl:'bgxkskkzz',
            imgurl:require('../assets/images/bgxkskkzz.png'),
            isLimits:false,
          },
          {
            name:'开车阀',
            en_name:'Diverter valve',
            linkurl:'kcf',
            imgurl:require('../assets/images/kcf.png'),
            isLimits:false,
          },
          {
            name:'三层摆页分配器',
            en_name:'3-layer swing-vane-type feedblock',
            linkurl:'scbyfpq',
            imgurl:require('../assets/images/scbyfpq.png'),
            isLimits:false,
          },
          {
            name:'组合镶块分配器',
            en_name:'Insert-type feedblock',
            linkurl:'zhxkfpq',
            imgurl:require('../assets/images/zhxkfpq.png'),
            isLimits:false,
          },
          {
            name:'模头快速开口结构',
            en_name:'Rapid opening structure of the die',
            linkurl:'lgskskkzz',
            imgurl:require('../assets/images/lgxkskkzz.jpg'),
            isLimits:false,
          },
          {
            name:'模头內挡结构',
            en_name:'Internal deckle structure of the die',
            linkurl:'mtndjg',
            imgurl:require('../assets/images/mtndjg.jpg'),
            isLimits:false,
          },
        ]
      }
    },
    methods:{
      shownav(){
        console.log('shownav');
        this.show_navlist=true
      },
      closenav(){
        console.log('closenav');
        this.show_navlist=false
      },
      Authorityjudgment(){
        const str = sessionStorage.getItem('limits');
        const arr = str.split(",");
        console.log(arr);
        for (let i = 0; i < this.itemlist.length; i++) {
          for(let j = 0; j < arr.length; j++){
            if(this.itemlist[i].linkurl == arr[j] || arr[j] == "*"){
              this.itemlist[i].isLimits = true
            }
          }
        }
        console.log(this.itemlist);
      },
      childchangelang(){
        this.lang = sessionStorage.getItem('language')
      },
    },
    mounted(){
        if(sessionStorage.getItem('language')){
          this.lang = sessionStorage.getItem('language'); // 存入一个值
        }else{
          sessionStorage.setItem('language',this.lang); // 存入一个值
        }
        this.Authorityjudgment()
    },
  }

</script>

<style scoped>
.navtransition-enter-active, .navtransition-leave-active {
  /* transition: opacity .5s; */
  transition: transform .5s;
}
.navtransition-enter, .navtransition-leave-to /* .navtransition-leave-active below version 2.1.8 */ {
  /* opacity: 0; */
  transform: translateX(100%);
}
.border{
  border: 1px solid #000;
}
.cover{
  position: absolute;
  z-index: 100;
}
.nav-btn{
  bottom: 20px;
  left: 20px;
  cursor: pointer;
}
.nav-btn img {
  width: 110px;
  height: 110px;
}
.product_list{
  right: 0px;
  width: 300px;
  height: 100vh;
  background-color: #fff;
  border-left: 1px solid #dddddd;
  overflow: scroll;
  /* padding-bottom: 200px; */
}
.product_title{
  /* position: relative;
  font-size: 20px;
  line-height: 60px;
  text-align: center;
  font-weight: 500;
  border-bottom: 1px solid #ddd; */
  position: fixed;
  font-size: 20px;
  line-height: 60px;
  padding-left: 82px;
  /* text-align: center; */
  font-weight: 500;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  width: 100%;
  z-index: 10;
}
.close {
  width: 22px;
  height: 22px;
  display: flex;
  /* right: 20px; */
  top: 50%;
  margin-top: -11px;
  position: absolute;
  left: 250px;
}
.product_item {
  border-radius: 5px;
  overflow: hidden;
  margin: 25px 25px 0;
  position: relative;
}
.product_item:nth-child(2){
  margin-top: 90px;
}
.image_con{
  width: 100%;
  height: 210px;
  transition: all .3s ease-in;
  overflow: hidden;
}
.product_item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all .3s ease-in;
  /* height: 210px;
  object-fit: cover;
  transition: all .3s ease-in; */
}
.title-name{
  text-align: center;
  margin: 5px auto;
}
.product_item .title {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  display: flex;
  align-items: center;
  opacity: 0;
  color: #fff;
  font-size: 18px;
  text-align: center;
  justify-content: center;
  background: rgba(0,0,0,.3);
  transition: all .3s ease-in;
}
.product_item a:hover img {
  transform: scale(1.05);
}
/* .product_item a:hover .title {
  opacity: 1;
} */
</style>



// WEBPACK FOOTER //
// src/components/nav.vue